import { apiPost, fmt } from "@/lib/api";
import { market } from "@/lib/symbols";

export const PositionsPanel = ({ positions, onChanged }) => {
  const closePos = async (id) => {
    await apiPost(`/positions/${id}/close`, {});
    onChanged?.();
  };

  if (!positions?.length) {
    return (
      <div className="border border-white/10 bg-[#0d1219] p-8 text-center" data-testid="positions-empty">
        <p className="font-mono text-xs text-mute-dim">
          &gt; tidak ada posisi terbuka — aktifkan robot paper auto di tab Settings
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto border border-white/10 bg-[#0d1219]" data-testid="positions-panel">
      <table className="w-full min-w-[720px] text-left font-mono text-xs">
        <thead>
          <tr className="border-b border-white/10 text-[9px] uppercase tracking-widest text-mute-dim">
            <th className="px-4 py-3">Simbol</th><th className="px-4 py-3">Arah</th><th className="px-4 py-3">Entry</th>
            <th className="px-4 py-3">Harga</th><th className="px-4 py-3">SL</th><th className="px-4 py-3">TP</th>
            <th className="px-4 py-3 text-right">PNL Live</th><th className="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          {positions.map((p) => (
            <tr key={p.id} className="border-b border-white/5" data-testid={`position-row-${p.symbol.toLowerCase()}`}>
              <td className="px-4 py-3 font-bold text-white">{p.symbol}</td>
              <td className={`px-4 py-3 font-bold ${p.direction === "BUY" ? "text-buy" : "text-sell"}`}>{p.direction}</td>
              <td className="px-4 py-3 text-mute">{p.entry}</td>
              <td className="px-4 py-3 text-white">{fmt(p.current_price, market[p.symbol]?.d ?? 2)}</td>
              <td className="px-4 py-3 text-sell">{p.sl}</td>
              <td className="px-4 py-3 text-buy">{p.tp}</td>
              <td className={`px-4 py-3 text-right font-bold ${(p.live_pnl ?? 0) >= 0 ? "text-buy" : "text-sell"}`}>
                {(p.live_pnl ?? 0) >= 0 ? "+" : ""}{fmt(p.live_pnl)}
              </td>
              <td className="px-4 py-3">
                <button onClick={() => closePos(p.id)} data-testid={`close-position-${p.id.slice(0, 8)}`}
                  className="border border-sell/40 px-2.5 py-1 text-[10px] font-bold text-sell transition-colors hover:bg-sell hover:text-white">
                  TUTUP
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
